import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const CommonModal = ({ isOpen, onClose, title, subTitle, children, footerContent }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

      {/* MODAL BOX */}
      <div className="
        bg-white dark:bg-cardbg w-[90%] sm:max-w-xl rounded-xl flex flex-col
        max-h-[90vh]
      ">

        {/* HEADER */}
        <div className="flex justify-between items-start p-4 border-b dark:border-bordercolor">

          <div>
            <h2 className="text-sm font-semibold text-[#0F172A] dark:text-textprimary">{title}</h2>
            <p className="text-xs text-[#64748B] dark:text-textsecondary mt-1">{subTitle}</p>
          </div>

          <button onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} className="text-lg text-[#64748B] dark:text-textsecondary" />
          </button>
        </div>

        {/* CONTENT */}
        <div className="p-4 overflow-y-auto flex-1 min-h-0">
          {children}
        </div>

        {/* FOOTER */}
        {footerContent && (
            <div className="px-4 py-3 border-t dark:border-bordercolor bg-gray-50/50 dark:bg-dashboardbg/50 rounded-b-xl">
                {footerContent}
            </div>
        )}

      </div>
    </div>
  );
};

export default CommonModal;